import request from '@/utils/request'

const itemApi = {
  queryBannerList: (params) => {
    return request({
      url: '/public/content',
      method: 'get',
      params
    })
  },
  queryItemCategory: () => {
    return request({
      url: '/item/category/query',
      method: 'get'
    })
  },
  queryItemList: (params) => {
    return request({
      url: '/item/list',
      method: 'get',
      params
    })
  },
  // 运费
  queryItemExpressConfigList: (params) => {
    return request({
      url: '/item/express/config/list',
      method: 'get',
      params
    })
  },
  queryItemInfo: (itemId) => {
    return request({
      url: '/item/info/' + itemId,
      method: 'get'
    })
  },
  // 商品评论列表
  queryItemComment: (params) => {
    return request({
      url: '/item/comment/query',
      method: 'get',
      params
    })
  },
  // 提交商品评价
  submitItemComment: (data) => {
    return request({
      url: '/item/comment/create',
      method: 'post',
      data
    })
  },
  // 获取商品评价
  getItemComment: (params) => {
    return request({
      url: '/item/comment/info',
      method: 'get',
      params
    })
  },
  // 更新商品评价
  updateItemComment: (data) => {
    return request({
      url: '/item/comment/update',
      method: 'post',
      data
    })
  },
  getPurchaseRanking: (params) => {
    return request({
      url: '/purchase-ranking/list',
      method: 'get',
      params
    })
  },
  queryAddressList: (params) => {
    return request({
      url: '/order/receivingAddress',
      method: 'get',
      params
    })
  },
  queryPocmList: (params) => {
    return request({
      url: '/public/pocm/list',
      method: 'get',
      params
    })
  },
  queryPocmCategory: () => {
    return request({
      url: '/public/pocm/category/query',
      method: 'get'
    })
  },
  queryPocmInfo: (itemId) => {
    return request({
      url: '/public/pocm/info/' + itemId,
      method: 'get'
    })
  },
  // 获取活动冰柜列表
  getCoolerGiftList: () => {
    return request({
      url: '/item/activity/list'
    })
  }
}
export default itemApi
